import { observer } from 'mobx-react';
import { useCallback } from 'react';
import deliveryZonesStore from '../../stores/deliveryZonesStore';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { DELIVERY_ZONE_TYPE } from 'src/types/deliveryManagment';
import { ColorBox } from 'src/view/components/Controls/ColorBox/ColorBox';
import Icon from 'src/view/components/Controls/Icon/Icon';
import MapZoom from 'src/view/components/Map/MapZoom/MapZoom';
import './style.scss';

export const DeliveryZoneMapControls = observer(() => {
  const zoomIn = useCallback(() => {
    deliveryZonesStore.mapStore.setZoom((deliveryZonesStore.mapStore.zoom || 0) + 1);
  }, []);

  const zoomOut = useCallback(() => {
    deliveryZonesStore.mapStore.setZoom((deliveryZonesStore.mapStore.zoom || 0) - 1);
  }, []);

  const onDelete = useCallback(() => {
    deliveryZonesStore.editDraftZone('bounds', []);
  }, []);

  return (
    <div>
      <div className="delivery-zone__map-tools ">
        {deliveryZonesStore.draft?.type === DELIVERY_ZONE_TYPE.PLYGON && deliveryZonesStore.draft.bounds.length ? (
          <span onClick={onDelete} className="delivery-zone__map-control animate__animated animate__faster animate__fadeInRight">
            <ColorBox size={48} color={theme.colors.red}>
              <Icon name={Icons.Trash} color={theme.colors.white} />
            </ColorBox>
          </span>
        ) : null}
      </div>

      <div className="delivery-zone__map-controls ">
        <MapZoom onZoomIn={zoomIn} onZoomOut={zoomOut} />
      </div>
    </div>
  );
});
